'use client'

import { useEffect, useState } from 'react'

interface Toast {
  id: string
  message: string
  type: 'success' | 'error'
}

export default function ToastNotification() {
  const [toasts, setToasts] = useState<Toast[]>([])

  useEffect(() => {
    const handleShowToast = (event: CustomEvent) => {
      const { message, type } = event.detail
      const id = Math.random().toString(36).slice(2, 11)

      setToasts(prev => [...prev, { id, message, type }])

      setTimeout(() => {
        setToasts(prev => prev.filter(toast => toast.id !== id))
      }, 3000)
    }

    window.addEventListener('showToast', handleShowToast as EventListener)

    return () => {
      window.removeEventListener('showToast', handleShowToast as EventListener)
    }
  }, [])

  if (toasts.length === 0) return null

  return (
    <div
      className="fixed z-[9999] space-y-2 pointer-events-none max-w-sm"
      style={{
        bottom: 'calc(20px + env(safe-area-inset-bottom, 0px))',
        right: 'calc(20px + env(safe-area-inset-right, 0px))',
      }}
    >
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={
            `px-4 py-2.5 rounded-xl shadow-lg text-sm font-medium transition-[transform,opacity] duration-300 transform animate-in slide-in-from-bottom-2 pointer-events-auto border backdrop-blur-md ${toast.type === 'success'
              ? 'bg-foreground/95 text-background border-border'
              : 'bg-destructive/95 text-white border-destructive/50'
            }`
          }
        >
          {toast.message}
        </div>
      ))}
    </div>
  )
}